/**
 *
 * Asynchronously loads the component for DMDC (VNeID) callback
 *
 */

import { lazyLoad } from 'src/utils/loadable';

export const CallbackDmdc = lazyLoad(
  () => import('./index'),
  (module: { CallbackDmdc: any }): any => module.CallbackDmdc,
);
